// @ts-nocheck
import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { SystemStatus } from './models/SystemStatus';
import { getEnvironment } from './utils';
import { Page } from '../common/enums';

export const SystemStatusSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  pharmacyId: types.maybeNull(types.number),
  subSystem: types.maybeNull(types.string),
  year: types.maybeNull(types.number),
});

export const SystemStatusStore = types
  .compose(
    getBaseStore<Instance<typeof SystemStatus>, Instance<typeof SystemStatus>>(
      SystemStatus,
      'systemStatusId',
      'systemStatus',
    ),
    types.model('SystemStatusStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const search = flow(function*(criteria: Instance<typeof SystemStatusSearchCriteria>) {
      const result = yield apiFetcher.get('systemStatus', {
        params: criteria,
      });
      // @ts-ignore
      const resultSystemStatus: Array<Instance<typeof SystemStatus>> = self.putInStore(result);
      return resultSystemStatus;
    });

    const saveSystemStatus = flow(function*(systemStatus: Instance<typeof SystemStatus>) {
      const res = yield self.saveElement(systemStatus);
      // @ts-ignore
      if (systemStatus.systemStatusId !== res.systemStatusId) {
        (root.ApplicationStore as Instance<typeof ApplicationStore>).navigate(
          // @ts-ignore
          `${Page.SystemStatusPage}/${res.systemStatusId}`,
        );
      }
    });

    const authorizeLogin = flow(function*() {
      yield apiFetcher.put('systemstatus/authorizeLogin', {});
    });

    const limitLogin = flow(function*(data) {
      yield apiFetcher.put('systemstatus/limitLogin', '"' + data.toLocaleString('fr-BE') + '"');
    });

    const minimalLogin = flow(function*() {
      yield apiFetcher.put('systemstatus/minimalLogin', {});
    });

    const getLoginState = flow(function*() {
      // const result = yield apiFetcher.put('systemstatus/limitLogin', {});
    });

    const startHangfire = flow(function*() {
      yield apiFetcher.put('systemstatus/startHangfire', {});
    });

    const stopHangfire = flow(function*() {
      yield apiFetcher.put('systemstatus/stopHangfire', {});
    });
    return {
      search,
      saveSystemStatus,
      authorizeLogin,
      limitLogin,
      minimalLogin,
      getLoginState,
      startHangfire,
      stopHangfire,
    };
  });

export type SystemStatusStoreType = Instance<typeof SystemStatusStore>;
